import { useQuery } from "react-query";
import { getHomeData, getPendingOrderData } from "./service";
import {
  getAssetsData,
  getProfileData,
  getFundChartsData,
  getFundsData,
  getAllPortfos,
} from "containers/services/services";
import { fundChartDataTransformer } from "./data.transformers";
import {
  getUserData,
} from "containers/services/data.transformers";
import config from "utils/globals";
import Cookies from "js-cookie";
import { setProfile } from "store/profile/action";
import { setActionHomeBalance, setAssets } from "store/general/action";
import { MetrixEvents } from "containers/services/events.data";

export const useHomeData = (instance, metrixInstance, dispatch) => {
  return useQuery(
    "homeData",
    async () => {
      const response = await getHomeData(instance);
      const user = await getUserData();
      MetrixEvents(metrixInstance, "hhagr", [
        { key: "user_id", value: user?.sub },
      ]);
      if (response) {
        dispatch(
          setActionHomeBalance(
            response?.filter((item) => item.type === "ASSET")[0]?.is_visible
          )
        );
      }
      return response;
    },
    {
      refetchInterval: 30 * 60 * 1000,
      staleTime: 30 * 60 * 1000,
    }
  );
};

export const useFundsData = (instance, data) => {
  return useQuery(
    "fundsData",
    async () => {
      const response = await getFundsData(instance);
      return config.sortArray(response, "priority")?.slice(0, 5);
    },
    {
      refetchInterval: 4 * 60 * 60 * 1000,
      staleTime: 4 * 60 * 60 * 1000,
      enabled:
        data?.length > 0 &&
        data.filter((item) => item.type === "FUND").length > 0,
    }
  );
};

export const usePmasData = (instance, data) => {
  return useQuery(
    "pmasData",
    async () => {
      const response = await getAllPortfos(instance);
      return config.sortArray(response, "priority")?.slice(0, 2);
    },
    {
      refetchInterval: 4 * 60 * 60 * 1000,
      staleTime: 4 * 60 * 60 * 1000,
      enabled:
        data?.length > 0 &&
        data.filter((item) => item.type === "PORTFOLIO").length > 0,
    }
  );
};

export const useFundChartsData = (instance, data, homeData) => {
  const fetchChartData = async (item) => {
    const params = {
      time_interval: "yearly",
      time_interval_type: "weekly",
    };

    const response = await getFundChartsData(instance, item?.ds_code, params);
    return {
      id: item?.ds_code,
      data: fundChartDataTransformer(response),
    };
  };

  return useQuery(
    "fundChartsData",
    async () => {
      const chartPromises = data?.map(fetchChartData);
      const chartsData = data && (await Promise.all(chartPromises));
      return [...chartsData];
    },
    {
      refetchInterval: 4 * 60 * 60 * 1000,
      staleTime: 4 * 60 * 60 * 1000,
      enabled:
        data?.length > 0 &&
        homeData?.filter((item) => item.type === "FUND")[0]?.is_visible,
    }
  );
};

export const useAssetData = (instance, data, visible, dispatch, assets) => {
  return useQuery(
    "assetData",
    async () => {
      const response = await getAssetsData(instance);
      if (response) {
        dispatch(setAssets(response));
      }
      return response;
    },
    {
      refetchInterval: 30 * 60 * 1000,
      staleTime: 30 * 60 * 1000,
      refetchOnMount: false, // Don't refetch on component remount
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      enabled:
        data?.length > 0 &&
        data.filter((item) => item.type === "ASSET").length > 0 &&
        visible &&
        !assets,
      initialData: assets,
    }
  );
};

export const usePendingOrdersData = (instance, data) => {
  return useQuery(
    "pendingOrdesData",
    async () => {
      const response = await getPendingOrderData(instance);
      return response;
    },
    {
      refetchOnWindowFocus: false,
      enabled:
        !!data &&
        data?.length > 0 &&
        data.filter((item) => item.type === "INQUIRY_FUND_ORDERS").length > 0,
    }
  );
};

export const useProfileData = (instance, setOpen, dispatch) => {
  return useQuery(
    "profileData",
    async () => {
      const response = await getProfileData(instance);
      response && dispatch(setProfile(response));
      if (
        response &&
        response.can_referral &&
        Cookies.get("referral_modal") === "true"
      ) {
        setOpen(true);
      }
    },
    {
      refetchInterval: 4 * 60 * 60 * 1000,
      staleTime: 4 * 60 * 60 * 1000,
    }
  );
};
